export class CurrencyService {
  getDefaultCurrency(currencies) {
    return currencies.find((item) => item.default)?.currency;
  }

  getDefaultCurrencySymbol(currencies) {
    return currencies.find((item) => item.default)?.symbol;
  }

  determineUserCurrency(hotelId, currencies) {
    const selectedUserCurrency = sessionStorage.getItem('currency' + hotelId);

    if (
      selectedUserCurrency &&
      currencies.some((currency) => currency.currency === selectedUserCurrency)
    ) {
      return selectedUserCurrency;
    }

    return this.getDefaultCurrency(currencies);
  }
}
